module.exports = __webpack_public_path__ + "media/categories/2016-ff877998.svg";